import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Select, Button, DatePicker, InputNumber, TimePicker, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const days = {
    'monday': 'Lunes',
    'tuesday': 'Martes',
    'wednesday': 'Miércoles',
    'thursday': 'Jueves',
    'friday': 'Viernes',
    'saturday': 'Sábado',
    'sunday': 'Domingo'
}

const FormPromotionPerDayResto = ({ onSubmit, isSaving, onResetFields, isSavedRestaurant }) => {

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
        onResetFields();
    }

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form} initialValues={{
                field_discount: 5,
                field_hour_from: moment('00:30', 'hh:mm'),
                field_hour_to: moment('00:00', 'hh:mm')
            }}>
                <Row>
                    <Col xs={12} sm={4} md={2}>
                        <Form.Item label="Día" name="field_day" rules={[{ required: true, message: 'Por favor, seleccione un día' }]}>
                            <Select placeholder="Día">
                                {
                                    Object.keys(days).map(key => <Option key={key} value={key}>{days[key]}</Option>)
                                } 
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={4} md={2}>
                        <Form.Item label="Descuento" name="field_discount" rules={[{ required: true, message: 'Por favor, seleccione el descuento' }]}>
                            <InputNumber
                            min={5}
                            max={100}
                            step={"5"}
                            formatter={value => `${value - (value % 5)}%`}
                            parser={value => value.replace('%', '')} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Item label="Vigencia - Fechas" name="field_date" rules={[{ required: true, message: 'Por favor, seleccione un rango válido de la fecha' }]}>
                            <RangePicker format={'DD/MM/YYYY'} disabledDate={(current) => {
                                let customDate = moment(new Date()).format("YYYY-MM-DD");
                                return current && current < moment(customDate, "YYYY-MM-DD");
                            }}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={3} md={2}>
                        <Form.Item label="Vigencia - Horas (desde)" name="field_hour_from" rules={[{ required: true, message: 'Por favor, seleccione un rango válido de horas'}]}>
                            <TimePicker format={'HH:mm'} minuteStep={30} disabledMinutes={(selectedHour) => { if(selectedHour=== 0) { return [0] }}} defaultOpenValue={moment('00:30', 'hh:mm')} placeholder={"Inicio"}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={3} md={2}>
                        <span><Form.Item label="Vigencia - Horas (hasta)" name="field_hour_to" rules={[{ required: true, message: 'Por favor, seleccione un rango válido de horas'}]}>
                            <TimePicker format={'HH:mm'} minuteStep={30} defaultOpenValue={moment('00:00', 'hh:mm')} placeholder={"Fin"}/>
                        </Form.Item> &nbsp; &nbsp; <Tooltip title="La hora '00' representa el final del día (24h)"><QuestionCircleOutlined /></Tooltip></span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Row center="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        isSaving ?
                                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                                Guardando
                                            </Button>
                                            :
                                            <Button type="primary" htmlType="submit">
                                                Guardar
                                            </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Row center="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        <Button disabled={isSaving} onClick={onReset}>
                                            Limpiar
                                        </Button>
                                    }
                                    {
                                        isSavedRestaurant && onReset()
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Grid>
    );
};

FormPromotionPerDayResto.propTypes = {
    onSubmit: PropTypes.func,
    isSaving: PropTypes.bool,
};

export default FormPromotionPerDayResto;